# ------------------------------------*|
#     #Font service
# ------------------------------------*|

moduleFont = angular.module 'api.font', []

moduleFont.factory 'Font', ["$timeout", "Restangular", "$http", ($timeout, Restangular, $http) ->
  font =
    getAll: ->
      Restangular.one("fonts").get()
    connectFonts: (fonts) ->
      _.each fonts, @connectFont

    defaultEmailFonts: [
      {
        id: "id1",
        family: "Arial, Helvetica, sans-serif",
        variants: ["regular", "bold", "lighter"],
        subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
      }
      {id: "id2", family: "Arial Black, Gadget, sans-serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
      {id: "id3", family: "Georgia, serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
      {id: "id4", family: "MS Sans Serif, Geneva, sans-serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
      {id: "id5", family: "MS Serif, New York, sans-serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
      {id: "id6", family: "Tahoma, Geneva, sans-serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
      {id: "id7", family: "Times New Roman, Times, serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
      {id: "id8", family: "Trebuchet MS, Helvetica, sans-serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
      {id: "id9", family: "Verdana, Geneva, sans-serif", variants: ["regular", "bold", "lighter"], subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]}
    ]

    defaultLessonFonts: [
      {
        id: "id1",
        family: "Montserrat",
        variants: ["100", "100italic", "300", "300italic", "regular", "italic", "700", "700italic", "900", "900italic"],
        subsets: ["latin-ext", "vietnamese", "cyrillic-ext", "latin", "cyrillic"]
      }
    ]

    # Подключаем шрифты ко всем в браузер, в ckeditor и в настройки сайта

    connectFont: (font) ->
      subsets = font.subsets.join(",")
      variants = font.variants.join(",")
      WebFont.load
        google:
          families: ["#{font.family}:#{variants}:#{subsets}"]
    defaults: []
  font
]



// WEBPACK FOOTER //
// ./src/app/editor/api/font.coffee